import { render } from "./EditorEditableText.vue?vue&type=template&id=70e07a6b"
import script from "./EditorEditableText.vue?vue&type=script&lang=js"
export * from "./EditorEditableText.vue?vue&type=script&lang=js"

import "./EditorEditableText.vue?vue&type=style&index=0&id=70e07a6b&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__